export default {
  STANDARD_TYPE_QUOTATION: 'standard',
  LEAD_TYPE_QUOTATION: 'lead'
}